export default __webpack_public_path__ + "static/media/discord-logo.96139a3b.svg";